const EVENT_DATE = {
  START: '2025-05-08T14:00:00+09:00',
  END: '2025-05-15T23:59:59+09:00',
} as const

const usePromotion = () => {
  const now = new Date()
  const start = new Date(EVENT_DATE.START)
  const end = new Date(EVENT_DATE.END)

  const isPromotionPeriod = now >= start && now <= end

  return { isPromotionPeriod }
}

export default usePromotion
